import { Post } from './post';
export class PostListResponse {
  public errorCode: string | null = null;
  public errorMessage: string | null = null;
  public forumPostResponses: Array<Post> = [];
  public pageNumber: number = 0;
  public pageSize: number = 0;
  public resultSize: number = 0;
  public success: boolean = true;
  public successMessage: string | null = null;
}
